module.exports = __webpack_public_path__ + "img/top_teikei.b5db5a39.gif";